var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zm-form',{ref:"addressForm",staticClass:"opc-payment__addr",attrs:{"rules":_vm.rules,"model":_vm.form,"label-position":"inline","disabled":_vm.disabled}},[_c('address-base-form',{attrs:{"form":_vm.form,"affix":"bill-to"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }